
export default{
    product:[ {
              key: 'Dunja (sve sorte)v:srednja p:standardno',
              sr :  'Dunja (sve sorte)',
              en :  'Quinces (all sorts)',
              category: 1
            },
            {
                key : 'Grožđe (belo Afuz Ali)v:srednja p:standardno',
                sr :  'Grožđe (belo Afuz Ali)',
                en :  'Grapes (white Afuz Ali)',
                category: 1
            },
            {
                key : 'Grožđe (belo Italija)v:srednja p:standardno',
                sr :  'Grožđe (belo Italija)',
                en :  'Grapes (white Italy)',
                category: 1
            },
            {
                key : 'Grožđe (belo Smederevka)v:srednja p:standardno',
                sr :  'Grožđe (belo Smederevka)',
                en :  'Grapes (white Smederevka)',
                category: 1
            },
            {
                key : 'Grožđe (belo ostale)v:srednja p:standardno',
                sr :  'Grožđe (belo ostale)',
                en :  'Grapes (white others)',
                category: 1
            },
            {
                key : 'Grožđe (crno Hamburg)v:srednja p:standardno',
                sr :  'Grožđe (crno Hamburg)',
                en :  'Grapes (black Hamburg)',
                category: 1
            },
            {
                key : 'Grožđe (crno Kardinal)v:srednja p:standardno',
                sr :  'Grožđe (crno Kardinal)',
                en :  'Grapes (black Cardinal)',
                category: 1
            },
            {
                key : 'Grožđe (crno ostale)v:srednja p:standardno',
                sr :  'Grožđe (crno ostale)',
                en :  'Grapes (black others)',
                category: 1
            },
            {
                key : 'Lešnik (očišćen)v:srednja p:standardno',
                sr :  'Lešnik (očišćen)',
                en :  'Hazelnut (cleaned)',
                category: 1
            },
            {
                key : 'Breskva (sve sorte)v:srednja p:standardno',
                sr :  'Breskva (sve sorte)',
                en :  'Fach (all sorts)',
                category: 1
            },
            {
                key : 'Borovnica (sve sorte)v:srednja p:standardno',
                sr :  'Borovnica (sve sorte)',
                en :  'Blueberry (all sorts)',
                category: 1
            },
            {
                key : 'Šljiva (suva)v:srednja p:posebno',
                sr :  'Šljiva (suva) srednja-posebno',
                en :  'Prunes medium-specific'
            },{
                key : 'Šljiva (suva)v:srednja p:standardno',
                sr :  'Šljiva (suva) srednja-standardno',
                en :  'Prunes medium-standard',
                category: 1
            },
            {
                key : 'Šljiva (sve sorte)v:srednja p:posebno',
                sr :  'Šljiva (sve sorte) srednja-posebno',
                en :  'Plum (all sorts) medium-specific',
                category: 1
            },{
                key : 'Šljiva (sve sorte)v:srednja p:standardno',
                sr :  'Šljiva (sve sorte) srednja-standardno',
                en :  'Plum (all sorts) medium-standard'
            },{
                key : 'Šljiva (sve sorte)v:velika p:standardno',
                sr :  'Šljiva (sve sorte) velika-standardno',
                en :  'Plum (all sorts) grand-standard',
                category: 1
            },
            {
                key : 'Kruška (Viljamovka)v:srednja p:standardno',
                sr :  'Kruška (Viljamovka) srednja-standardno',
                en :  'Pear (WILLIAMS PEAR)',
                category: 1
            },{
                key : 'Kruška (ostale)v:srednja p:standardno',
                sr :  'Kruška (ostale) srednja-standardno',
                en :  'Pear (others) medium-standard',
                category: 1
            },{
                key : 'Kruška (ostale)v:velika p:standardno',
                sr :  'Kruška (ostale) velika-standardno',
                en :  'Pear (others) grand-standard',
                category: 1
            },
            {
                key : 'Jabuka (Ajdared)v:srednja p:standardno',
                sr :  'Jabuka (Ajdared) srednja-standardno',
                en :  'Apple (Ajdared) medium-standard',
                category: 1
            }, {
                key : 'Jabuka (Ajdared)v:velika p:standardno',
                sr :  'Jabuka (Ajdared) velika-standardno',
                en :  'Apple (Ajdared) grand-standard',
                category: 1
            },
            {
                key : 'Jabuka (Delišes ruž.)v:srednja p:standardno',
                sr :  'Jabuka (Delišes ruž.) srednja-standardno',
                en :  'Apple (RED-CIF) medium-standard',
                category: 1
            },{
                key : 'Jabuka (Delišes zlatni)v:srednja p:standardno',
                sr :  'Jabuka (Delišes zlatni) srednja-standardno',
                en :  'Apple (GOLDEN DELICIOUS) medium-standard'
            },{
                key : 'Jabuka (Delišes zlatni)v:velika p:standardno',
                sr :  'Jabuka (Delišes zlatni) velika-standardno',
                en :  'Apple (GOLDEN DELICIOUS) grand-standard',
                category: 1
            },
            {
                key : 'Jabuka (Gloster)v:srednja p:standardno',
                sr :  'Jabuka (Gloster) srednja-standardno',
                en :  'Apple (Gloster) medium-standard',
                category: 1
            },
            {
                key : 'Jabuka (Greni Smit)v:srednja p:standardno',
                sr :  'Jabuka (Greni Smit) srednja-standardno',
                en :  'Apple (Granny Smith) medium-standard',
                category: 1
            },{
                key : 'Jabuka (Greni Smit)v:velika p:standardno',
                sr :  'Jabuka (Greni Smit) velika-standardno',
                en :  'Apple (Granny Smith) grand-standard',
                category: 1
            },{
                key : 'Jabuka (Jonagold)v:srednja p:standardno',
                sr :  'Jabuka (Jonagold) srednja-standardno',
                en :  'Apple (Jonagold) medium-standard',
                category: 1
            },{
                key : 'Jabuka (Mucu)v:srednja p:standardno',
                sr :  'Jabuka (Mucu) srednja-standardno',
                en :  'Apple (Mucu) medium-standard',
                category: 1
            },{
                key : 'Jabuka (Melrouz)v:srednja p:standardno',
                sr :  'Jabuka (Melrouz) srednja-standardno',
                en :  'Apple (Melrouz) medium-standard',
                category: 1
            },{
                key : 'Jabuka (ostale)v:srednja p:standardno',
                sr :  'Jabuka (ostale) srednja-standardno',
                en :  'Apple (others) medium-standard'
            },{
                key : 'Jabuka (ostale)v:velika p:standardno',
                sr :  'Jabuka (ostale) velika-standardno',
                en :  'Apple (others) grand-standard',
                category: 1
            },
            {
                key : 'Kupina (sve sorte)v:srednja p:standardno',
                sr :  'Kupina (sve sorte) srednja-standardno',
                en :  'Blackberry (all sorts) medium-standard',
                category: 1
            },
            {
                key : 'Malina (sve sorte)v:srednja p:posebno',
                sr :  'Malina (sve sorte) srednja-posebno',
                en :  'Raspberry (all sorts) medium-specific',
                category: 1
            }, {
                key : 'Malina (sve sorte)v:srednja p:standardno',
                sr :  'Malina (sve sorte) srednja-standardno',
                en :  'Raspberry (all sorts) medium-standard',
                category: 1
            },
            {
                key : 'Trešnja (sve sorte)v:srednja p:standardno',
                sr :  'Trešnja (sve sorte) srednja-standardno',
                en :  'Cherry (all sorts) medium-standard',
                category: 1
            },{
                key : 'Trešnja (sve sorte)v:velika p:standardno',
                sr :  'Trešnja (sve sorte) velika-standardno',
                en :  'Cherry (all sorts) grand-standard',
                category: 1
            },{
                key : 'Višnja (sve sorte)v:srednja p:standardno',
                sr :  'Višnja (sve sorte) srednja-standardno',
                en :  'Cherry (small) (all sorts) medium-standard',
                category: 1
            },{
                key : 'Višnja (sve sorte)v:velika p:standardno',
                sr :  'Višnja (sve sorte) velika-standardno',
                en :  'Cherry (small)  (all sorts) grand-standard',
                category: 1
            },
            {
                key : 'Nektarina (sve sorte)v:srednja p:standardno',
                sr :  'Nektarina (sve sorte) srednja-standardno',
                en :  'Nectarine (all sorts) medium-standard',
                category: 1
            },{
                key : 'Nektarina (sve sorte)v:velika p:standardno',
                sr :  'Nektarina (sve sorte) velika-standardno',
                en :  'Nectarine (all sorts) grand-standard',
                category: 1
            },{
                key : 'Orah (očišćen)v:srednja p:standardno',
                sr :  'Orah (očišćen)',
                en :  'Walnut (cleaned)',
                category: 1
            },{
                key : 'Smokva (suva)v:srednja p:posebno',
                sr :  'Smokva (suva) srednja-posebno',
                en :  'Dried figs medium-specific',
                category: 1
            },{
                key : 'Smokva (suva)v:srednja p:standardno',
                sr :  'Smokva (suva) srednja-standardno',
                en :  'Dried figs medium-standard',
                category: 1
            },{
                key : 'Smokva (sve sorte)v:srednja p:posebno',
                sr :  'Smokva (sve sorte) srednja-posebno',
                en :  'Fig (all sorts) medium-specific',
                category: 1
            },{
                key : 'Smokva (sve sorte)v:srednja p:standardno',
                sr :  'Smokva (sve sorte) srednja-standardno',
                en :  'Fig (all sorts) medium-standard',
                category: 1
            },{
                key : 'Kajsija (sve sorte)v:srednja p:standardno',
                sr :  'Kajsija (sve sorte) srednja-standardno',
                en :  'Apricot (all sorts) medium-standard',
                category: 1
            },{
                key : 'Kajsija (sve sorte)v:velika p:standardno',
                sr :  'Kajsija (sve sorte) velika-standardno',
                en :  'Apricot (all sorts) grand-standard',
                category: 1
            },{
                key : 'Jagoda (sve sorte)v:srednja p:standardno',
                sr :  'Jagoda (sve sorte) srednja-standardno',
                en :  'Strawberry (all sorts) medium-standard',
                category: 1
            },{
                key : 'Jagoda (sve sorte)v:velika p:posebno',
                sr :  'Jagoda (sve sorte) velika-posebno',
                en :  'Strawberry (all sorts) grand-specific',
                category: 1
            },{
                key : 'Šargarepa (sve sorte)v:srednja p:standardno',
                sr :  'Šargarepa (sve sorte)',
                en :  'Carrots (all sorts)',
                category: 2
            },{
                key : 'Cvekla (sve sorte)v:srednja p:standardno',
                sr :  'Cvekla (sve sorte)',
                en :  'Beet (all sorts)',
                category: 2
            },{
                key : 'Krompir (beli)v:srednja p:standardno',
                sr :  'Krompir (beli) srednja-standardno',
                en :  'Potato (white) medium-standard',
                category: 2
            },{
                key : 'Krompir (crveni)v:srednja p:standardno',
                sr :  'Krompir (crveni) srednja-standardno',
                en :  'Potato (red) medium-standard',
                category: 2
            },{
                key : 'Krompir (mladi )v:srednja p:posebno',
                sr :  'Krompir (mladi) srednja-posebno',
                en :  'Potato (young) medium-specific',
                category: 2
            },{
                key : 'Krompir (mladi )v:srednja p:standardno',
                sr :  'Krompir (mladi) srednja-standardno',
                en :  'Beet (young) medium-standard',
                category: 2
            },{
                key : 'Kupus (mladi)v:srednja p:standardno',
                sr :  'Kupus (mladi)',
                en :  'Cabbage (young)',
                category: 2
            },{
                key : 'Kupus (sve sorte)v:srednja p:standardno',
                sr :  'Kupus (sve sorte)',
                en :  'Cabbage (all sorts)',
                category: 2
            },
            {
                key : 'Pečurke (šampinjoni)v:srednja p:posebno',
                sr :  'Pečurke (šampinjoni) srednja-posebno',
                en :  'Mushrooms (champignons) medium-specific',
                category: 2
            },{
                key : 'Pečurke (šampinjoni)v:srednja p:standardno',
                sr :  'Pečurke (šampinjoni) srednja-standardno',
                en :  'Mushrooms (champignons) medium-standard',
                category: 2
            },{
                key : 'Celer (sve sorte)v:srednja p:standardno',
                sr :  'Celer (sve sorte)',
                en :  'Celery (all sorts)',
                category: 2
            },
            {
                key : 'Blitva (sve sorte)v:srednja p:standardno',
                sr :  'Blitva (sve sorte)',
                en :  'Chard (all sorts)',
                category: 2
            },{
                key : 'Dinja (sve sorte)v:srednja p:standardno',
                sr :  'Dinja (sve sorte)',
                en :  'Melon (all sorts)',
                category: 2
            },{
                key : 'Karfiol (sve sorte)v:srednja p:standardno',
                sr :  'Karfiol (sve sorte)',
                en :  'Cauliflower (all sorts)',
                category: 2
            },{
                key : 'Kelj (sve sorte)v:srednja p:standardno',
                sr :  'Kelj (sve sorte)',
                en :  'Kale (all sorts)',
                category: 2
            },{
                key : 'Krastavac (Kornišon)v:srednja p:standardno',
                sr :  'Krastavac (Kornišon) srednja-standardno',
                en :  'Cucumber (Kornišon) medium-standard',
                category: 2
            },{
                key : 'Krastavac (salatar)v:srednja p:posebno',
                sr :  'Krastavac (salatar) srednja-posebno',
                en :  'Cucumber (salatar) medium-specific',
                category: 2
            },{
                key : 'Krastavac (salatar)v:srednja p:standardno',
                sr :  'Krastavac (salatar) srednja-standardno',
                en :  'Cucumber (salatar) medium-standard',
                category: 2
            },{
                key : 'Boranija (žuta)v:srednja p:standardno',
                sr :  'Boranija (žuta)',
                en :  'Beans (yellow)',
                category: 2
            },{
                key : 'Boranija (šarena)v:srednja p:standardno',
                sr :  'Boranija (šarena)',
                en :  'Beans (colorful)',
                category: 2
            },{
                key : 'Boranija (olovka)v:srednja p:standardno',
                sr :  'Boranija (olovka)',
                en :  'Beans (olovka)',
                category: 2
            },{
                key : 'Lubenica (sve sorte)v:srednja p:standardno',
                sr :  'Lubenica (sve sorte)',
                en :  'Watermelon (all sorts)',
                category: 2
            },{
                key : 'Luk beli (sve sorte)v:srednja p:standardno',
                sr :  'Luk beli (sve sorte)',
                en :  'Garlic (all sorts)',
                category: 2
            },{
                key : 'Luk crni (mladi)v:srednja p:standardno',
                sr :  'Luk crni (mladi)',
                en :  'Onion (yong)',
                category: 2
            },{
                key : 'Luk crni (sve sorte)v:srednja p:standardno',
                sr :  'Luk crni (sve sorte)',
                en :  'Onion (all sorts)',
                category: 2
            },{
                key : 'Paprika (Babura)v:srednja p:standardno',
                sr :  'Paprika (Babura)',
                en :  'Pepper (Babura)',
                category: 2
            },{
                key : 'Paprika (ljuta)v:srednja p:posebno',
                sr :  'Paprika (ljuta) srednja-posebno',
                en :  'Pepper (chili) medium-specific',
                category: 2
            },{
                key : 'Paprika (ljuta)v:srednja p:standardno',
                sr :  'Paprika (ljuta) srednja-standardno',
                en :  'Pepper (chili) medium-standard',
                category: 2
            },{
                key : 'Paprika (ostala)v:srednja p:standardno',
                sr :  'Paprika (ostala)',
                en :  'Pepper (others)',
                category: 2
            },{
                key : 'Paprika (šilja)v:srednja p:standardno',
                sr :  'Paprika (šilja)',
                en :  'Pepper (šilja)',
                category: 2
            },{
                key : 'Paradajz (chery)v:srednja p:posebno',
                sr :  'Paradajz (chery) srednja-posebno',
                en :  'Tomato (chery) medium-specific',
                category: 2
            },{
                key : 'Paradajz (chery)v:srednja p:standardno',
                sr :  'Paradajz (chery) srednja-standardno',
                en :  'Tomato (chery) medium-standard',
                category: 2
            },{
                key : 'Paradajz (zeleni)v:srednja p:standardno',
                sr :  'Paradajz (zeleni) srednja-standardno',
                en :  'Tomato (green) medium-standard',
                category: 2
            },{
                key : 'Paradajz (sve sorte)v:srednja p:posebno',
                sr :  'Paradajz (sve sorte) srednja-posebno',
                en :  'Tomato (all sorts) medium-specific',
                category: 2
            },{
                key : 'Paradajz (sve sorte)v:srednja p:standardno',
                sr :  'Paradajz (sve sorte) srednja-standardno',
                en :  'Tomato (all sorts) medium-standard',
                category: 2
            },{
                key : 'Pasulj (beli gradištanac)v:srednja p:standardno',
                sr :  'Pasulj (beli gradištanac)',
                en :  'Beans (white gradištanac)',
                category: 2
            },{
                key : 'Pasulj (beli tetovac)v:srednja p:standardno',
                sr :  'Pasulj (beli tetovac)',
                en :  'Beans (white tetovac)',
                category: 2
            },{
                key : 'Pasulj (beli)v:srednja p:standardno',
                sr :  'Pasulj (beli)',
                en :  'Beans (white)',
                category: 2
            },{
                key : 'Pasulj (šareni)v:srednja p:standardno',
                sr :  'Pasulj (šareni)',
                en :  'Beans (colorful)',
                category: 2
            },{
                key : 'Pasulj (žuti)v:srednja p:standardno',
                sr :  'Pasulj (žuti)',
                en :  'Beans (yellow)',
                category: 2
            },{
                key : 'Patlidžan (sve sorte)v:srednja p:standardno',
                sr :  'Patlidžan (sve sorte)',
                en :  'Eggplant (all sorts)',
                category: 2
            },{
                key : 'Paškanat (sve sorte)v:srednja p:standardno',
                sr :  'Paškanat (sve sorte)',
                en :  'Parsnip (all sorts)',
                category: 2
            },{
                key : 'Peršun (korenaš)v:srednja p:standardno',
                sr :  'Peršun (korenaš)',
                en :  'Parsley (root)',
                category: 2
            },{
                key : 'Peršun (lišćar)v:srednja p:standardno',
                sr :  'Peršun (lišćar)',
                en :  'Parsley (leaf)',
                category: 2
            },{
                key : 'Praziluk (sve sorte)v:srednja p:standardno',
                sr :  'Praziluk (sve sorte)',
                en :  'Leek (all sorts)',
                category: 2
            },{
                key : 'Rotkvica (sve sorte)v:srednja p:standardno',
                sr :  'Rotkvica (sve sorte)',
                en :  'Radish (all sorts)',
                category: 2
            },{
                key : 'Spanać (sve sorte)v:srednja p:standardno',
                sr :  'Spanać (sve sorte)',
                en :  'Spinach (all sorts)',
                category: 2
            },{
                key : 'Tikvice (sve sorte)v:srednja p:standardno',
                sr :  'Tikvice (sve sorte)',
                en :  'Zucchini (all sorts)',
                category: 2
            },{
                key : 'Zelen (sve sorte)v:srednja p:standardno',
                sr :  'Zelen (sve sorte)',
                en :  'Green (all sorts)',
                category: 2
            },{
                key : 'Zelena salata (sve sorte)v:srednja p:standardno',
                sr :  'Zelena salata (sve sorte)',
                en :  'Lettuce (all sorts)',
                category: 2
            },{
                key : 'Zelje (sve sorte)v:srednja p:standardno',
                sr :  'Zelje (sve sorte)',
                en :  '',
                category: 2
            },{
                key : 'Ren (sve sorte)v:srednja p:standardno',
                sr :  'Ren (sve sorte)',
                en :  'Horseradish (all sorts)',
                category: 2
            },{
                key : 'Rotkva (sve sorte)v:srednja p:standardno',
                sr :  'Rotkva (sve sorte)',
                en :  'Radish (all sorts)',
                category: 2
            },{
                key : 'Brokola (sve sorte)v:srednja p:standardno',
                sr :  'Brokola (sve sorte)',
                en :  'Broccoli (all sorts)',
                category: 2
            },{
                key : 'Kukuruz (okrunjen, prirodno sušen)',
                sr :  'Kukuruz (okrunjen, prirodno sušen)',
                en :  'Corn (crowned, naturally dried)',
                category: 4
            },{
                key : 'Kukuruz (okrunjen, veštački sušen)',
                sr :  'Kukuruz (okrunjen, veštački sušen)',
                en :  'Corn (artificial, naturally dried)',
                category: 4
            },{
                key : 'Kukuruz (u klipu)',
                sr :  'Kukuruz (u klipu)',
                en :  'Corn (Corn on the Cob)',
                category: 4
            },{
                key : 'Lucerka (seno u balama)',
                sr :  'Lucerka (seno u balama)',
                en :  'Alfalfa (hay in bales)',
                category: 4
            },{
                key : 'Pšenica',
                sr :  'Pšenica',
                en :  'Wheat',
                category: 4
            },{
                key : 'Sojino zrno',
                sr :  'Sojino zrno',
                en :  'Soybean',
                category: 4
            },{
                key : 'Stočni ječam',
                sr :  'Stočni ječam',
                en :  'Fodder barley',
                category: 4
            },{
                key : 'Stočno brašno',
                sr :  'Stočno brašno',
                en :  'Livestock flour',
                category: 4
            },{
                key : 'Bikovi',
                sr :  'Bikovi',
                en :  'Bulls',
                category: 3
            },{
                key : 'Jagnjad',
                sr :  'Jagnjad',
                en :  'Lambs',
                category: 3
            },{
                key : 'Jarad',
                sr :  'Jarad',
                en :  'Goatlings',
                category: 3
            },{
                key : 'Junad',
                sr :  'Junad',
                en :  'Heifers  ',
                category: 3
            },{
                key : 'Koze',
                sr :  'Koze',
                en :  'Goats',
                category: 3
            },{
                key : 'Krave za klanje',
                sr :  'Krave za klanje',
                en :  'Cows for butchering',
                category: 3
            },{
                key : 'Telad',
                sr :  'Telad',
                en :  'Calves',
                category: 3
            },{
                key : 'Ovca',
                sr :  'Ovca',
                en :  'Sheep',
                category: 3
            },{
                key : 'Krmače za klanje',
                sr :  'Krmače za klanje',
                en :  'Sows for butchering',
                category: 3
            },{
                key : 'Prasad',
                sr :  'Prasad',
                en :  'Piglets ',
                category: 3
            },
            {
                key : 'Tovljenici',
                sr :  'Tovljenici',
                en :  'Fatteners',
                category: 3
            },{
                key : 'Ovnovi za priplod',
                sr :  'Ovnovi za priplod',
                en :  'Rams for breeding',
                category: 3
            },{
                key : 'Priplodne junice',
                sr :  'Priplodne junice',
                en :  'Breeding heifers',
                category: 3
            },{
                key : 'Priplodne nazimice',
                sr :  'Priplodne nazimice',
                en :  'Breeding gilts',
                category: 3
            },{
                key : 'Kivi (sve sorte)v:srednja p:posebno',
                sr :  'Kivi (sve sorte) srednja-posebno',
                en :  'Kiwi (all sorts) medium-specific',
                category: 1
            },{
                key : 'Kivi (sve sorte)v:srednja p:standardno',
                sr :  'Kivi (sve sorte) srednja-standardno',
                en :  'Kiwi (all sorts) medium-standard',
                category: 1
            },{
                key : 'Mandarina (sve sorte)v:srednja p:standardno',
                sr :  'Mandarina (sve sorte) srednja-standardno',
                en :  'Mandarin  (all sorts) medium-standard',
                category: 1
            },{
                key : 'Mandarina (sve sorte)v:velika p:standardno',
                sr :  'Mandarina (sve sorte) velika-standardno',
                en :  'Mandarin  (all sorts) grand-standard',
                category: 1
            },{
                key : 'Grejpfrut (sve sorte)v:srednja p:standardno',
                sr :  'Grejpfrut (sve sorte) srednja-standardno',
                en :  'Grapefruit (all sorts) medium-standard',
                category: 1
            },{
                key : 'Limun (sve sorte)v:srednja p:standardno',
                sr :  'Limun (sve sorte) srednja-standardno',
                en :  'Lemon (all sorts) medium-standard',
                category: 1
            },{
                key : 'Nar (sve sorte)v:srednja p:standardno',
                sr :  'Nar (sve sorte) srednja-standardno',
                en :  'Pomegranate (all sorts) medium-standard',
                category: 1
            },{
                key : 'Banana (sve sorte)v:srednja p:standardno',
                sr :  'Banana (sve sorte) srednja-standardno',
                en :  'Banana (all sorts) medium-standard',
                category: 1
            },{
                key : 'Ananas (sve sorte)v:srednja p:standardno',
                sr :  'Ananas (sve sorte) srednja-standardno',
                en :  'Pineapple  (all sorts) medium-standard',
                category: 1
            },{
                key : 'Pomorandža (sve sorte)v:srednja p:standardno',
                sr :  'Pomorandža (sve sorte) srednja-standardno',
                en :  'Orange (all sorts) medium-standard',
                category: 1
            },{
                key : 'Pomorandža (sve sorte)v:velika p:standardno',
                sr :  'Pomorandža (sve sorte) velika-standardno',
                en :  'Orange (all sorts) grand-standard',
                category: 1
            },{
                key : 'Jaja (L)',
                sr :  'Jaja (L)',
                en :  'Eggs (L)',
                category: 12
            },{
                key : 'Jaja (XL)',
                sr :  'Jaja (XL)',
                en :  'Eggs (XL)',
                category: 12
            },{
                key : 'Jaja (S)',
                sr :  'Jaja (S)',
                en :  'Eggs (S)',
                category: 12
            },{
                key : 'Jaja (M)',
                sr :  'Jaja (M)',
                en :  'Eggs (M)',
                category: 12
            },{
                key : 'Mleko',
                sr :  'Mleko',
                en :  'Milk',
                category: 10
            },{
                key : 'Piletina (sve rase)',
                sr :  'Piletina (sve rase)',
                en :  'Chicken (all sorts)',
                category: 12
            },{
                key : 'Kajmak',
                sr :  'Kajmak',
                en :  'Cream (kajmak)',
                category: 11
            },{
                key : 'Beli sir (masni)',
                sr :  'Beli sir (masni)',
                en :  'White cheese (fat)',
                category: 11
            },{
                key : 'Beli sir (polumasni)',
                sr :  'Beli sir (polumasni)',
                en :  'White cheese (medium fat)',
                category: 11
            },{
                key : 'Dviske',
                sr :  'Dviske',
                en :  'Sheep (1 year old)',
                category: 3
            },
            {
                key : 'Šilježad',
                sr :  'Šilježad',
                en :  'Lambs (3 to 4 months old)',
                category: 3
            }
        ] 
}
